import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';

declare var formValidation: any;
declare var $: any;

@Component({
    selector: 'app-question-email',
    templateUrl: './question-email.component.html',
    styleUrls: ['./question-email.component.scss'],
    standalone: false
})
export class QuestionEmailComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = false;
  @Input() isIdInput = false;
  @Input() clearValues = false;
  @Input() inputType = '';
  @Input() labelText = '';
  @Input() placeHolderText = '';
  @Input() value = '';
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  //value = '';
  verify = '';
  valid = true;
  validator: any;
  user: any;
  constructor(
    public globalQuestionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery,
    private userStore: UserStore
  ) {
    this.user = this.userStore.getValue();
    
    
  }

  ngOnInit(): void {
    if (this.question?.answer) {
      this.value = this.question.answer;
    }
    this.validator = formValidation;
    this.validator.init({
      form: '#email-verify-form',
    });
    if (this.user.broker_id > 0){
      $('#'+this.question.cent_aq_question_id).html("Please confirm <strong>your client's</strong> email address and contact number.")
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.clearValues = changes?.clearValues?.currentValue;
    if (this.clearValues) {
      this.clearEmail();
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;
    }
  }

  validateEmail(email): void {
    this.valid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(email);
  }

  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57) {
      this.value = this.value.toUpperCase();
    }
  }

  saveValue(): void {
    this.validateEmail(this.value);
    if (this.value && this.valid) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    } else {
      this.clearEmail();
    }
  }



  clearEmail(): void {
    this.value = '';
    this.verify = '';
    this.question.answer = '';
    this.questionAnswer.emit(this.question);
  }

}
